<template>
  <bcg-response-tab-test-screenshots-view
    v-if="loaded"
    :data="data"/>
  <error-view
    v-else-if="error"
    :error="error"
    @reload="load"/>
  <vpreloader v-else/>
</template>
<script>

  import {STORE_PREFIX} from '../constants'
  import {createNamespacedHelpers} from 'vuex'
  import BcgResponseTabTestScreenshotsView from '../components/screenshots-view';
  import ErrorView from '@/process/_components/error-view';

  const {mapGetters, mapActions} = createNamespacedHelpers(STORE_PREFIX + 'screenshots');

  export default {
    name: 'bcg-response-tab-test-screenshots',
    components: {
      BcgResponseTabTestScreenshotsView,
      ErrorView,
    },
    computed: {
      ...mapGetters(['error', 'loaded', 'data'])
    },
    methods: {
      ...mapActions(['load'])
    },
    beforeMount () {
      this.load();
    }
  }
</script>
